export enum BaseGameState {
    ROULETTE_SPINNING= 'ROULETTE_SPINNING',
    BETS_PLACING = 'BETS_PLACING'
}